import * as types from './mutation-types'

const mutation = {
    [types.ACTIVE_TPP](state, data) {
      state.activeThirdPartyPartners = data
    },
    [types.ALL_TPP](state, data) {
      state.allThirdPartyPartners = data
    },
    [types.SET_SELECTED_THIRDPARTY_PARTNER](state, partner) {
      state.selectedThirdPartyPartner = partner
    } 
  }
  
  export default mutation


// WEBPACK FOOTER //
// ./src/store/modules/thirdparty/mutations.js